import React, { Component } from 'react';
class DenominacionCuartaLinea extends Component {
    constructor( props ) {
        super( props );
    }
    handleChange(e){

        if(/^[a-záéíóúñÑÁÉÍÓÚ\-A-Z0-9\s]*$/.test(e.target.value)){
            this.props.onBlurTextBox("denominacionCuartaLinea", e.target.value)
        }
    }
    
    componentWillReceiveProps(nextprops){
        const {  data, solicitudCuenta, onBlurTextBox,tarjetas } = this.props;
        let parametrosGenerales = solicitudCuenta.GET_ATLAS_PARAMETRO_GENERAL;
        let productoSeleccionado = solicitudCuenta.productoVisaSeleccionado ? solicitudCuenta.productoVisaSeleccionado : solicitudCuenta.ProductoCabalSeleccionado;
        
        let textoCuartaLinea = "";

        //SI ES UNA CUENTA EXISTENTE, LA DENOMINACIÓN DE CUARTA LÍNEA DEFAULT ES LA DE LA TARJETA REGISTRADA CON EL ID MÁS ALTO
        if(tarjetas.esCuentaExistente && parametrosGenerales.SINODENOMINACIONCUARTALINEA && data.denominacionCuartaLinea == null && Array.isArray(data.cuentasAdicionales) && data.cuentasAdicionales.length>0){
            let idMayor = 0;
            let cuartaLinea;
            data.cuentasAdicionales.map(cuenta=>{if(cuenta.Id>idMayor && cuenta.SolicitudId){idMayor = cuenta.Id ; cuartaLinea = cuenta.CuartaLinea} });
            if(cuartaLinea) onBlurTextBox("denominacionCuartaLinea", cuartaLinea);
        }

        if (tarjetas.tipoEmpresa.EmpresaIndividuos=="E" && parametrosGenerales.SINODENOMINACIONCUARTALINEA && productoSeleccionado && productoSeleccionado.TipoGrabadoCuartaLinea && data.denominacionCuartaLinea == null && !tarjetas.esCuentaExistente) {
            
            if (productoSeleccionado.TipoGrabadoCuartaLinea == "Cartera" && solicitudCuenta && solicitudCuenta.carteraId){
                textoCuartaLinea = (solicitudCuenta.GET_CARTERAS_PRODUCTO && solicitudCuenta.GET_CARTERAS_PRODUCTO.length>0 && solicitudCuenta.carteraId>0) ? solicitudCuenta.GET_CARTERAS_PRODUCTO.filter(cartera => cartera.Id == solicitudCuenta.carteraId)[0].Descripcion: ' ';
            }
            else if (productoSeleccionado.TipoGrabadoCuartaLinea == "GAF" && solicitudCuenta && solicitudCuenta.grupoAfinidadSeleccionadoId){
                textoCuartaLinea = (solicitudCuenta.ATLAS_GRUPO_AFINIDAD && solicitudCuenta.ATLAS_GRUPO_AFINIDAD.length > 0 && solicitudCuenta.grupoAfinidadSeleccionadoId >0 ) ? solicitudCuenta.ATLAS_GRUPO_AFINIDAD.filter(cartera => cartera.Id == solicitudCuenta.grupoAfinidadSeleccionadoId)[0].Descripcion: ' ';
            }
            else if (productoSeleccionado.TipoGrabadoCuartaLinea == "Sucursal" && solicitudCuenta && solicitudCuenta.sucursalSeleccionadaId){
                textoCuartaLinea = (solicitudCuenta.ATLAS_SUCURSALES && solicitudCuenta.ATLAS_SUCURSALES.length>0 && solicitudCuenta.sucursalSeleccionadaId > 0) ? solicitudCuenta.ATLAS_SUCURSALES.filter(cartera => cartera.Id == solicitudCuenta.sucursalSeleccionadaId)[0].Descripcion : ' ';
            }
            else if (productoSeleccionado.TipoGrabadoCuartaLinea == "ModLiq" && solicitudCuenta && solicitudCuenta.modeloLiquidacionId ){
                textoCuartaLinea = (solicitudCuenta.GET_MODELO_LIQUIDACION_PRODUCTO && solicitudCuenta.GET_MODELO_LIQUIDACION_PRODUCTO.length >0 &&  parseInt(solicitudCuenta.modeloLiquidacionId) >0) ? solicitudCuenta.GET_MODELO_LIQUIDACION_PRODUCTO.filter(cartera => cartera.ID == solicitudCuenta.modeloLiquidacionId)[0].DESCRIPCION:' ';
            }
            else if (productoSeleccionado.TipoGrabadoCuartaLinea == "Texto")
                textoCuartaLinea = productoSeleccionado.TextoCuartaLinea;

            if (textoCuartaLinea != ' ') {
                onBlurTextBox("denominacionCuartaLinea", textoCuartaLinea);
            }
        }else if(tarjetas.tipoEmpresa.EmpresaIndividuos=="I" && parametrosGenerales.SINODENOMINACIONCUARTALINEA && data.denominacionCuartaLinea == null && solicitudCuenta.denominacionCuartaLinea){
            onBlurTextBox("denominacionCuartaLinea", solicitudCuenta.denominacionCuartaLinea);
        }

    }    
    
   
    render() {
      const {data}=this.props
        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <label className="label-primary">Denominación 4ta Línea</label>
                    <div className="row">
                        <div className="col-xs-2">
                            <label className="label-secondary">Grabado 4ta Línea</label>
                        </div>
                        <div className="col-xs-2">
                        <input className="input-separate inputAlta" 
                            type="text" 
                            id="denominacionCuartaLineaText"
                            value={data.denominacionCuartaLinea} 
                            onChange={this.handleChange.bind(this)}
                            maxLength="19"
                        />

                        </div>
                    </div>
                </div>
                <div className="col-xs-12">
                {(data.ERROR_ADICIONAL["seleccionoDenominacionCuartaLinea"] == false)
                    && <label className="error">{"Debe agregar una denominación de cuarta línea"}</label>
                }
                </div>
            </div>
        )
    }
};

export default DenominacionCuartaLinea;